module.exports = __webpack_public_path__ + "static/media/articles.1915fc97.svg";